import { useController, useFormContext } from 'react-hook-form';

import { FormField } from 'ui/formField';
import { TextArea } from 'ui/inputs';

import { FormFieldKey } from './types';
import {
  CHANGE_COMMENT_INPUT_HELP_TEXT,
  CHANGE_COMMENT_INPUT_LABEL,
  CHANGE_COMMENT_INPUT_PLACEHOLDER,
} from './constants';

export const ChangeCommentInput = () => {
  const { control } = useFormContext();
  const {
    field: { onChange, value },
  } = useController({ name: FormFieldKey.ChangeComment, control, defaultValue: '' });

  return (
    <FormField labelText={CHANGE_COMMENT_INPUT_LABEL} helpText={CHANGE_COMMENT_INPUT_HELP_TEXT}>
      <TextArea
        value={value}
        onChange={(newValue) => onChange({ target: { value: newValue } })}
        placeholder={CHANGE_COMMENT_INPUT_PLACEHOLDER}
      />
    </FormField>
  );
};
